var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-title-list-view is-multiple-detail",
      attrs: { id: _vm.id }
    },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.data ? "Edit Tab" : "Add Tab"))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.dataSetup.title,
              expression: "dataSetup.title"
            }
          ],
          class: { "error-input": _vm.$v.dataSetup.title.$error },
          attrs: { placeholder: "Tab Title", type: "text" },
          domProps: { value: _vm.dataSetup.title },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.dataSetup, "title", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex mt-4",
          class: _vm.data ? "justify-content-between" : "justify-content-end"
        },
        [
          _vm.data
            ? _c(
                "button",
                {
                  staticClass: "button-border",
                  on: {
                    click: function($event) {
                      _vm.$emit("delete-tab")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-trash mr-2" }),
                  _vm._v(" Delete\n    ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "button",
              {
                staticClass: "button-border mr-2",
                on: {
                  click: function($event) {
                    _vm.$emit("close-modal")
                  }
                }
              },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button-blue",
                attrs: { disabled: !_vm.dataSetup.title },
                on: { click: _vm.submitForm }
              },
              [_vm._v("\n        Apply\n      ")]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c08062f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c08062f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalSetupTab.vue
// module id = null
// module chunks = 